export default __webpack_public_path__ + "54c7eb2b7f2f3678e4e09d7669561897.webp";